import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
const routes = [
  // 登录
  {
    path: '/',
    name: 'Login',
    component: () => import('../components/Login.vue')
  },


  {
    path: '/Layout',
    name: 'Layout',
    component: () => import('../views/Layout'),
    children: [
      // 主页面
      {
        path: '/Home',
        name: 'Home',
        components: {
          content: () => import('../views/Home')
        }
      },
      // 织造工位
      //  {
      //   path: '/index1',
      //   name: '织造工位',
      //   components: {
      //     content: () => import('../views/zhizao/index1')
      //   },
      //   meta: {
      //     keepAlive: true
      //   }
      // },
      // 织造工位
      {
        path: '/zhizao',
        name: '织造工位',
        components: {
          content: () => import('../views/zhizao/zhizao')
        },
        meta: {
          keepAlive: true
        }
      }, // 织造工位---报工
      {
        path: '/zhizao/fiberOk',
        name: '织造工位---报工',
        components: {
          content: () => import('../views/zhizao/fiberOk')
        }
      },
      {
        path: '/zhizao/JTfiberOk',
        name: '织造工位---接头报工',
        components: {
          content: () => import('../views/zhizao/JTfiberOk')
        }
      },

      // 织造工位---生产报表
      {
        path: '/zhizao/SCbaobiao',
        name: '织造工位---生产报表',
        components: {
          content: () => import('../views/zhizao/SCbaobiao')
        }
      },
      // 织造工位--任务书查看
      {
        path: '/zhizao/renwushu',
        name: '织造工位--任务书查看',
        components: {
          content: () => import('../views/zhizao/renwushu')
        }
      },

      // 打样报工
      {
        path: '/zhizao/DyfiberOk',
        name: '打样报工',
        components: {
          content: () => import('../views/zhizao/DyfiberOk')
        }
      },
      //     // 后整理
      //     {
      //       path: '/houzhengli',
      //       name: '后整理',
      //       components: {
      //         content: () => import('../views/houzhengli/houzhengli')
      //       }
      //     },
      //     // 后整理--生产报工
      //     {
      //       path: '/houzhengli/fiberOk',
      //       name: '后整理--生产报工',
      //       components: {
      //         content: () => import('../views/houzhengli/fiberOk')
      //       }
      //     },
      //     // 打卷打码
      //     {
      //       path: '/dajuandama',
      //       name: '打卷打码',
      //       components: {
      //         content: () => import('../views/dajuandama/dajuandama')
      //       }
      //     },
      //     // 打卷打码---重大码
      //     {
      //       path: '/dajuandama/chongdama',
      //       name: '打卷打码---重打码',
      //       components: {
      //         content: () => import('../views/dajuandama/chongdama')
      //       }
      //     },
      //     // 打卷打码---检验修改
      //     {
      //       path: '/dajuandama/jianyanxiugai',
      //       name: '打卷打码---检验修改',
      //       components: {
      //         content: () => import('../views/dajuandama/jianyanxiugai')
      //       }
      //     },
      //     // 打卷打码---检验修改--详情
      //     {
      //       path: '/dajuandama/jianyanxiugaiDetail',
      //       name: '打卷打码---检验修改--详情',
      //       components: {
      //         content: () => import('../views/dajuandama/jianyanxiugaiDetail')
      //       }
      //     },
      //     // 生产领料
      //     {
      //       path: '/shengchanlingliao',
      //       name: '生产领料',
      //       components: {
      //         content: () => import('../views/shengchanlingliao/shengchanlingliao')
      //       }
      //     },
      //     // 生产领料--生产报工
      //     {
      //       path: '/shengchanlingliao/fiberOk',
      //       name: '生产领料--生产报工',
      //       components: {
      //         content: () => import('../views/shengchanlingliao/fiberOk')
      //       }
      //     },

      //     // // 半成品
      //     // {
      //     //   path: '/banchengpinjian',
      //     //   name: '半成品检验',
      //     //   components: {
      //     //     content: () => import('../views/bcp/banchengpinjian'),
      //     //   }
      //     // },

      //     // // 半成品检验报表
      //     // {
      //     //   path: '/bcpjianyanbaobiao',
      //     //   name: '半成品检验报表',
      //     //   components: {
      //     //     content: () => import('../views/bcp/bcpjianyanbaobiao'),
      //     //   }
      //     // },
      //     // 其他缺陷
      //     {
      //       path: '/other',
      //       name: '其他缺陷',
      //       components: {
      //         content: () => import('../views/bcp/other')
      //       }
      //     },
      //   ],
      // },
      // {
      //   path: '/cp',
      //   name: 'cp',
      //   component: () => import('../views/cp.vue'),
      //   redirect: '/kaijian',
      //   children: [
      //     //开翦
      //     {
      //       path: '/kaijian',
      //       name: '开剪',
      //       component: () => import('../views/cp/kaijian')
      //     },
      //     // 开翦-流水号详情
      //     {
      //       path: '/cpDetail',
      //       name: '开翦-流水号详情',
      //       component: () => import('../views/cp/cpDetail')
      //     },
      //     // 拼卷
      //     {
      //       path: '/pinjuan',
      //       name: '拼卷',
      //       component: () => import('../views/cp/pinjuan')
      //     },
      //     // 成品检验拼卷详情
      //     {
      //       path: '/pinjuanDetail',
      //       name: '成品检验拼卷详情',
      //       component: () => import('../views/cp/pinjuanDetail')
      //     },
      //     // 成品检验拼卷当日列表
      //     {
      //       path: '/checkList',
      //       name: '成品检验拼卷当日列表',
      //       component: () => import('../views/cp/checkList')
      //     },
      //     // 检验修改
      //     {
      //       path: '/jianyanxiugai',
      //       name: '检验修改',
      //       component: () => import('../views/cp/jianyanxiugai')
      //     },
      //     // 检验修改详情
      //     {
      //       path: '/jianyanxiugaiDetail',
      //       name: '检验修改详情',
      //       component: () => import('../views/cp/jianyanxiugaiDetail'),
      //     },
      //     // 检验报表
      //     {
      //       path: '/jianyanbaobiao',
      //       name: '检验报表',
      //       component: () => import('../views/cp/jianyanbaobiao'),
      //     },
      //     // 成品缺陷录入
      //     {
      //       path: '/cpDefect',
      //       name: '成品缺陷录入',
      //       component: () => import('../views/cp/cpDefect')
      //     },
    ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router